import { render, staticRenderFns } from "./RotateChevron.vue?vue&type=template&id=21af854e&scoped=true"
import script from "./RotateChevron.vue?vue&type=script&lang=js"
export * from "./RotateChevron.vue?vue&type=script&lang=js"
import style0 from "./RotateChevron.vue?vue&type=style&index=0&id=21af854e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21af854e",
  null
  
)

export default component.exports